{
  "hero": {
    "eyebrow": "How it works",
    "title": "Monetise today the future cash flows",
    "highlight": "of your assets",
    "subtitle": "A guided, transparent process: from the analysis of your asset portfolio to the discounting of future cash flows."
  },
  "ctaTitle": "Ready to multiply your portfolio's capacity?",
  "schema": {
    "fotovoltaico": "Photovoltaic",
    "eolico": "Wind",
    "tariffaFissa": "fixed tariff",
    "tariffaVar": "variable tariff",
    "context": {
      "goals": "business goals",
      "portfolio": "your portfolio",
      "tools": "growth tools"
    },
    "contractDone": "Contract closed",
    "counterpartyShare": "Counterparty share",
    "yourShare": "Your share",
    "revenuePlusGo": "Profits + GO"
  },
  "modelCta": {
    "primary": "Discover who we serve",
    "secondary": "Contact us"
  },
  "dashboard": {
    "title": "Producer Dashboard",
    "period": "July 2026",
    "goRevenue": "GO Revenue",
    "goRevenueUnit": "EUR this month",
    "goIssued": "GOs issued",
    "goIssuedUnit": "Guarantees of Origin",
    "activePlants": "Active plants",
    "activePlantsUnit": "out of 4 total",
    "chartTitle": "Monthly production and GOs",
    "production": "production",
    "issued": "issued",
    "sold": "sold",
    "yourPlants": "Your plants",
    "viewAll": "View all"
  },
  "console": {
    "statusPending": "Qualifying"
  },
  "charts": {
    "cashflow": "NET CASH FLOW · 10 YEARS",
    "actualized": "DISCOUNTED TO TODAY",
    "sharing": "SHARING · PROFITS + GO"
  },
  "model": {
    "steps": [
      {
        "k": "Step 01 · The context",
        "t": "Tell us your goals, your portfolio and the tools you use to expand it.",
        "d": "In a preliminary phase, DEC Energy sets out to understand the financial and growth targets of your renewable asset portfolio, the route-to-market you adopted and the financing tools you use."
      },
      {
        "k": "Step 02 · Plant identification",
        "t": "We craft the best offer for your plants and guide you through the contract terms.",
        "d": "To reach the discounted cash you are after, DEC Energy supports you in selecting the best asset and defining the contract terms to propose to our counterparties."
      },
      {
        "k": "Step 03 · The upfront cash",
        "t": "Immediately collect part of your future cash flows.",
        "d": "Together we select the contractual counterparty and sign the agreement. You receive the discounted cash in a single payment."
      },
      {
        "k": "Step 04 · During the agreement",
        "t": "Share profits and Guarantees of Origin based on production performance.",
        "d": "For the entire duration of the agreement, keep selling electricity and paying your financing costs and OPEX as before. At year end, you share the Guarantees of Origin and part of the generated profits with the counterparty."
      },
      {
        "k": "Step 05 · At the end of the agreement",
        "t": "Become once again the sole beneficiary of the production.",
        "d": "When the contract ends, the counterparty has no further rights over your plant. All the profits and Guarantees of Origin the plant produces belong to you as its owner."
      }
    ]
  }
}
